import { useAuth } from '@/providers/auth.provider'
import { useEffect, useState } from 'react'

type Props = {
  children: any
  roles: Array<string>
}

function Permission(props: Props) {
  const [allowed, setallowed] = useState(false)
  const { user } = useAuth()
  useEffect(() => {
    if (user) {
      setallowed(
        props.roles.some((role) => role == user.subscription?.role_access?.role)
          ? true
          : false
      )
    }
  }, [user])

  if (!allowed) return null
  return props.children
}

export default Permission
